import { render, staticRenderFns } from "./facebookPosts.vue?vue&type=template&id=4d2e9bbe&scoped=true&"
import script from "./facebookPosts.vue?vue&type=script&lang=js&"
export * from "./facebookPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e9bbe",
  null
  
)

export default component.exports